import React from 'react'
// import './specials.scss'
import AutoMenu from '../../react/AutoMenu'
import {Link} from 'react-router-dom'
export default function () {
  return(
    <div className="catering-page">
      <div className="top-banner" style={{backgroundImage: "url(https://image.shutterstock.com/z/stock-photo-chef-making-beef-burgers-outdoor-on-open-kitchen-international-food-festival-event-street-food-709571101.jpg)"}}>
        <h1>Catering</h1>
      </div>

      <AutoMenu categorysToShow={['wRUahsJVZYei3wxPcs5q']} />

      <div className="full-menu-link-wrapper">
        <Link to="/order" className="button">Go to Full Menu</Link>
      </div>
    </div>
  )
}
